import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import { getUtmParams } from "@/common/utmParams";
export var sendSellTrade = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = _objectSpread(_objectSpread({
            "seller_name": data === null || data === void 0 ? void 0 : data.seller_name,
            "seller_mobile": data === null || data === void 0 ? void 0 : data.seller_mobile,
            "car_make_id": data === null || data === void 0 ? void 0 : data.car_make_id,
            "car_model_id": data === null || data === void 0 ? void 0 : data.car_model_id,
            "car_trim_id": data === null || data === void 0 ? void 0 : data.car_trim_id,
            "year": data === null || data === void 0 ? void 0 : data.year,
            "odometer_range_id": data === null || data === void 0 ? void 0 : data.odometer_range_id,
            "city_id": data === null || data === void 0 ? void 0 : data.city_id,
            "send_whatsApp_notification": data === null || data === void 0 ? void 0 : data.send_whatsApp_notification,
            "ownership_type": data === null || data === void 0 ? void 0 : data.ownership_type
          }, data !== null && data !== void 0 && data.experiment_group ? {
            experiment_group: data.experiment_group
          } : {}), getUtmParams());
          _context.n = 1;
          return fetcher(null).post("sell-trade/send-sell-trade-v2", params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function sendSellTrade(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getStep = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2) {
    var request_id, landing_page, params, res;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          request_id = _ref2.request_id, landing_page = _ref2.landing_page;
          params = {
            request_id: request_id
          };
          if (landing_page !== undefined) {
            params.landing_page = landing_page;
          }
          _context2.n = 1;
          return fetcher(null).get("sell-trade/get-step", {
            params: params
          });
        case 1:
          res = _context2.v;
          return _context2.a(2, res || null);
      }
    }, _callee2);
  }));
  return function getStep(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// Submit Sell Trade Step

export var submitSellTradeStep = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
    var res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return fetcher(null).post("sell-trade/submit", data);
        case 1:
          res = _context3.v;
          return _context3.a(2, res || null);
      }
    }, _callee3);
  }));
  return function submitSellTradeStep(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

// Reschedule Times API

export var getRescheduleTimes = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref5) {
    var day, request_id, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          day = _ref5.day, request_id = _ref5.request_id;
          _context4.n = 1;
          return fetcher(null).get("sell-trade/reschedule-times", {
            params: {
              day: day,
              "null": 'null',
              request_id: request_id
            }
          });
        case 1:
          res = _context4.v;
          return _context4.a(2, res || null);
      }
    }, _callee4);
  }));
  return function getRescheduleTimes(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

// Submit Date and Time

export var submitDateTime = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
    var res;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return fetcher(null).post("sell-trade/submit", data);
        case 1:
          res = _context5.v;
          return _context5.a(2, res || null);
      }
    }, _callee5);
  }));
  return function submitDateTime(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

// Update to Previous Step

export var updateToPreviousStep = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(data) {
    var res;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return fetcher(null).post("sell-trade/update-to-previous-step", data);
        case 1:
          res = _context6.v;
          return _context6.a(2, res || null);
      }
    }, _callee6);
  }));
  return function updateToPreviousStep(_x6) {
    return _ref8.apply(this, arguments);
  };
}();

// Cancel Sell Trade

export var cancelSellTrade = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
    var res;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          _context7.n = 1;
          return fetcher(null).post("sell-trade/cancel", data);
        case 1:
          res = _context7.v;
          return _context7.a(2, res || null);
      }
    }, _callee7);
  }));
  return function cancelSellTrade(_x7) {
    return _ref9.apply(this, arguments);
  };
}();

// Get Reschedule Data

export var getReschedule = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref0) {
    var request_id, res;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          request_id = _ref0.request_id;
          _context8.n = 1;
          return fetcher(null).get("sell-trade/get-reschedule", {
            params: {
              request_id: request_id
            }
          });
        case 1:
          res = _context8.v;
          return _context8.a(2, res || null);
      }
    }, _callee8);
  }));
  return function getReschedule(_x8) {
    return _ref1.apply(this, arguments);
  };
}();

// Get Step Validation

export var getStepValidation = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref10) {
    var _res$data;
    var request_id, res;
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          request_id = _ref10.request_id;
          _context9.n = 1;
          return fetcher(null).get("sell-trade/get-step-validation", {
            params: {
              request_id: request_id
            }
          });
        case 1:
          res = _context9.v;
          return _context9.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || null);
      }
    }, _callee9);
  }));
  return function getStepValidation(_x9) {
    return _ref11.apply(this, arguments);
  };
}();